export default __webpack_public_path__ + "static/media/HeroImage.8010fc57.png";